import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { LabelButton, TextLink } from '@teamsnap/snap-ui';
import { AuthContext, User } from 'auth';
import { APP_URL } from 'core';
import {
  DemoType,
  TeamsnapAppFeatureCallout,
  useTeamsnapAppAdUpsellActions,
} from './shared';

const learnMoreLink =
  'https://www.teamsnap.com/leagues-and-clubs/join-leagueside-sports-organization-sponsorships';

type RouteParams = { orgId: string };

const Sponsorships: React.FC<RouteComponentProps<RouteParams>> = ({
  match: {
    params: { orgId },
  },
}) => {
  React.useEffect(() => {
    window.scrollTo({
      top: 0,
    });
  }, []);

  const { user } = React.useContext(AuthContext);

  const [learnMore] = useTeamsnapAppAdUpsellActions(
    user as User,
    DemoType.Sponsorships,
    orgId
  );

  return (
    <div id="sponsorships" className="container hub-full-width">
      <div className="page-content sui-p-4">
        <header className="sui-flex sui-flex-col d:sui-flex-row d:sui-justify-between sui-mb-4 sui-gap-2">
          <div>
            <img
              className="sui-h-[60px]"
              alt="sponsorship-title-black"
              src={`${APP_URL}/images/sponsorship-title-black.png`}
            />
          </div>
          <div>
            <LabelButton
              icon="arrow_forward"
              iconPosition="right"
              labelText="Get Sponsored"
              sentiment="default"
              size="default"
              variantType="primary"
              onClick={(e) => {
                e.preventDefault();
                learnMore(learnMoreLink);
              }}
            />
          </div>
        </header>

        <div className="sui-flex-col d:sui-flex-row sui-flex sui-gap-3">
          <TeamsnapAppFeatureCallout>
            No additional cost
          </TeamsnapAppFeatureCallout>
          <TeamsnapAppFeatureCallout>
            Quick to Sign Up, Easy to Execute
          </TeamsnapAppFeatureCallout>
          <TeamsnapAppFeatureCallout>
            Average Sponsorship Value of $1,500 Per Season
          </TeamsnapAppFeatureCallout>
        </div>

        <div className="sui-flex sui-flex-col-reverse d:sui-flex-row sui-gap-[64px] sui-mt-4 d:sui-mt-6 sui-items-center">
          <div>
            <h1 className="sui-heading-md sui-mb-2">Get Sponsored!</h1>
            <p className="sui-mb-2">
              As a member of TeamSnap, you now have access to a new innovative
              way to fund your youth sports organization through sponsorships.
            </p>
            <p className="sui-mb-2">
              TeamSnap Sponsorship makes youth sports more accessible by
              connecting organizations like yours with regional and national
              brands as sponsors. And, there&apos;s no additional cost!
            </p>
            <p className="sui-mb-2">
              We've helped countless organizations unlock new revenue streams
              and create lasting partnerships with top-tier brands, adding both
              credibility and visibility for your entire program. These
              partnerships are win-win relationships, as sponsors often offer
              benefits like development workshops and more.
            </p>
            <p className="sui-mb-2">
              By joining the TeamSnap Sponsorship network, you&apos;ll get
              access to valuable financial support (average sponsorships are
              $1,500 per season… in cash!). Signing up is easy. Become eligible
              in just 5 minutes and unlock amazing opportunities sent straight
              to your inbox. You&apos;ll then execute sponsorships seamlessly
              with our dashboard and support team by your side, and join the 81%
              of partners who rate us 10/10 in user experience!
            </p>
            <p className="sui-mb-2">
              Want to get sponsored today?
              <TextLink
                href={learnMoreLink}
                onClick={(e) => {
                  e.preventDefault();
                  learnMore(learnMoreLink);
                }}
              >
                &nbsp;Click Here&nbsp;
              </TextLink>
              to learn more!
            </p>
          </div>
          <img
            className="sui-w-full sui-h-[259px] d:sui-w-[515px] d:sui-h-[362px]"
            alt="sponsorships"
            src={`${APP_URL}/images/sponsorships-image.png`}
          />
        </div>
      </div>
    </div>
  );
};

export default Sponsorships;
